module.exports = __webpack_public_path__ + "img/9.7d7afa5a.jpg";